export const transcribeLanguages: { key: string; label: string }[] = [
  { key: 'ab-GE', label: 'Abkhaz' },
  { key: 'af-ZA', label: 'Afrikaans' },
  { key: 'ar-AE', label: 'Arabic (UAE)' },
  { key: 'ar-SA', label: 'Arabic (Saudi Arabia)' },
  { key: 'ast-ES', label: 'Asturian' },
  { key: 'az-AZ', label: 'Azerbaijani' },
  { key: 'ba-RU', label: 'Bashkir' },
  { key: 'be-BY', label: 'Belarusian' },
  { key: 'bg-BG', label: 'Bulgarian' },
  { key: 'bn-IN', label: 'Bengali (India)' },
  { key: 'bs-BA', label: 'Bosnian' },
  { key: 'ca-ES', label: 'Catalan' },
  { key: 'ckb-IQ', label: 'Kurdish (Sorani, Iraq)' },
  { key: 'ckb-IR', label: 'Kurdish (Sorani, Iran)' },
  { key: 'cs-CZ', label: 'Czech' },
  { key: 'cy-WL', label: 'Welsh' },
  { key: 'da-DK', label: 'Danish' },
  { key: 'de-CH', label: 'German (Switzerland)' },
  { key: 'de-DE', label: 'German (Germany)' },
  { key: 'el-GR', label: 'Greek' },
  { key: 'en-AB', label: 'English (Abkhazia)' },
  { key: 'en-AU', label: 'English (Australia)' },
  { key: 'en-GB', label: 'English (UK)' },
  { key: 'en-IE', label: 'English (Ireland)' },
  { key: 'en-IN', label: 'English (India)' },
  { key: 'en-NZ', label: 'English (New Zealand)' },
  { key: 'en-US', label: 'English (US)' },
  { key: 'en-WL', label: 'English (Wales)' },
  { key: 'en-ZA', label: 'English (South Africa)' },
  { key: 'es-ES', label: 'Spanish (Spain)' },
  { key: 'es-US', label: 'Spanish (US)' },
  { key: 'et-EE', label: 'Estonian' },
  { key: 'et-ET', label: 'Estonian (Ethiopia?)' },
  { key: 'eu-ES', label: 'Basque' },
  { key: 'fa-IR', label: 'Persian (Farsi)' },
  { key: 'fi-FI', label: 'Finnish' },
  { key: 'fr-CA', label: 'French (Canada)' },
  { key: 'fr-FR', label: 'French (France)' },
  { key: 'gl-ES', label: 'Galician' },
  { key: 'gu-IN', label: 'Gujarati' },
  { key: 'ha-NG', label: 'Hausa' },
  { key: 'he-IL', label: 'Hebrew' },
  { key: 'hi-IN', label: 'Hindi' },
  { key: 'hr-HR', label: 'Croatian' },
  { key: 'hu-HU', label: 'Hungarian' },
  { key: 'hy-AM', label: 'Armenian' },
  { key: 'id-ID', label: 'Indonesian' },
  { key: 'is-IS', label: 'Icelandic' },
  { key: 'it-IT', label: 'Italian' },
  { key: 'ja-JP', label: 'Japanese' },
  { key: 'kab-DZ', label: 'Kabyle' },
  { key: 'ka-GE', label: 'Georgian' },
  { key: 'kk-KZ', label: 'Kazakh' },
  { key: 'kn-IN', label: 'Kannada' },
  { key: 'ko-KR', label: 'Korean' },
  { key: 'ky-KG', label: 'Kyrgyz' },
  { key: 'lg-IN', label: 'Ganda (Uganda)' },
  { key: 'lt-LT', label: 'Lithuanian' },
  { key: 'lv-LV', label: 'Latvian' },
  { key: 'mhr-RU', label: 'Meadow Mari' },
  { key: 'mi-NZ', label: 'Maori' },
  { key: 'mk-MK', label: 'Macedonian' },
  { key: 'ml-IN', label: 'Malayalam' },
  { key: 'mn-MN', label: 'Mongolian' },
  { key: 'mr-IN', label: 'Marathi' },
  { key: 'ms-MY', label: 'Malay' },
  { key: 'mt-MT', label: 'Maltese' },
  { key: 'nl-NL', label: 'Dutch' },
  { key: 'no-NO', label: 'Norwegian' },
  { key: 'or-IN', label: 'Odia' },
  { key: 'pa-IN', label: 'Punjabi' },
  { key: 'pl-PL', label: 'Polish' },
  { key: 'ps-AF', label: 'Pashto' },
  { key: 'pt-BR', label: 'Portuguese (Brazil)' },
  { key: 'pt-PT', label: 'Portuguese (Portugal)' },
  { key: 'ro-RO', label: 'Romanian' },
  { key: 'ru-RU', label: 'Russian' },
  { key: 'rw-RW', label: 'Kinyarwanda' },
  { key: 'si-LK', label: 'Sinhala' },
  { key: 'sk-SK', label: 'Slovak' },
  { key: 'sl-SI', label: 'Slovenian' },
  { key: 'so-SO', label: 'Somali' },
  { key: 'sr-RS', label: 'Serbian' },
  { key: 'su-ID', label: 'Sundanese' },
  { key: 'sv-SE', label: 'Swedish' },
  { key: 'sw-BI', label: 'Swahili (Burundi)' },
  { key: 'sw-KE', label: 'Swahili (Kenya)' },
  { key: 'sw-RW', label: 'Swahili (Rwanda)' },
  { key: 'sw-TZ', label: 'Swahili (Tanzania)' },
  { key: 'sw-UG', label: 'Swahili (Uganda)' },
  { key: 'ta-IN', label: 'Tamil' },
  { key: 'te-IN', label: 'Telugu' },
  { key: 'th-TH', label: 'Thai' },
  { key: 'tl-PH', label: 'Tagalog' },
  { key: 'tr-TR', label: 'Turkish' },
  { key: 'tt-RU', label: 'Tatar' },
  { key: 'ug-CN', label: 'Uyghur' },
  { key: 'uk-UA', label: 'Ukrainian' },
  { key: 'uz-UZ', label: 'Uzbek' },
  { key: 'vi-VN', label: 'Vietnamese' },
  { key: 'wo-SN', label: 'Wolof' },
  { key: 'zh-CN', label: 'Chinese (Simplified)' },
  { key: 'zh-HK', label: 'Chinese (Hong Kong)' },
  { key: 'zh-TW', label: 'Chinese (Traditional)' },
  { key: 'zu-ZA', label: 'Zulu' }
];
